import React, { useEffect, useState } from "react"
import Seo from "../components/Seo/seo"
import Layout from "../components/Layout/layout"
import * as Styled from "../components/Post/styled"
import WavesDark from "../../static/assets/svg/layered-waves-dark.svg"
import WavesLight from "../../static/assets/svg/layered-waves-light.svg"



export default function AboutPage() {
  const [theme, setTheme] = useState("dark")

  const isDarkMode = theme === "dark"

  useEffect(() => {
    setTheme(window.__theme)
    window.__onThemeChange = () => setTheme(window.__theme)
  },[] )

  return (
    <Layout>
      <Seo title="Sobre Mim" />
      {isDarkMode ? <Styled.ComplexWaveDark/> : <Styled.ComplexWaveLight/> }
      <Styled.BlobStyle />
      <Styled.MainContent>
        <h1>O mestre do Front-End</h1>
        <h3>Quem sou eu?</h3>
        <p>Sou um apaixonado por tech formado em eletrônica pelo Instituto Federal Catarinense, atualmente
          estudando Ciência da Computação na PUCPR </p>
        <h3>O que eu já fiz ?</h3>
        <ul>
          <li>
            Já atuei como programador desktop para um ERP Industrial, utilizado por mais de 20 industrias.
          </li>
          <li>
            Trabalhei como desenvolvedor web, criando páginas inúmeras em React e WordPress.
          </li>
          <li>
            Possuo experiencia internacional, criando interfaces de sistemas de gerenciamento de Aeronaves em Angular.
          </li>
        </ul>
        <h3>Com o que eu sonho ?</h3>
        <p>Eu sonho em poder criar as melhores expriências para meus colegas desenvolvedores e transformar a comunidade tech em algo melhor do que já é.</p>
      </Styled.MainContent>
      {isDarkMode ? <WavesDark style={{ position: "relative", marginTop: "-40vh" ,marginLeft: "-40vh"}} /> : <WavesLight style={{ position: "relative", marginTop: "-40vh" ,marginLeft: "-40vh"}} />}
    </Layout>
  )
}

